import { generateUniqueKey } from "@/utils/generateUniqueKey";

const anonymousId = localStorage.getItem("anonymousId");
if (!anonymousId) {
  localStorage.setItem("anonymousId", generateUniqueKey());
}
